import Button from '@ui/Button'
import Breadcrumb from '@common/Breadcrumb'
import {ROUTES,SITE } from '@/constants'
import TransformBanner from '@sections/TransformBanner'
import MetaInfo from '@common/MetaInfo'
import { metaTitleFor } from '../assets/js/navBreadcrumb'
const { label, pageDesc, metaDesc } = metaTitleFor(ROUTES.GENAI_INTELLIGENT_ASSISTANTS)

const WE_CAN_BUILD = [
  {title: 'Business Knowledge Assistants',
    desc: `Create assistants that help employees find answers from approved company documents, manuals, policies, product information and internal knowledge resources.
Using approaches such as retrieval-augmented generation (RAG), an application can retrieve relevant source material and provide a response grounded in that material. The design can also include source references, permission checks and safeguards against unsupported answers.`,
    example:'An organization with extensive policy documents could provide an internal assistant that helps employees locate the correct procedure without manually searching through multiple files.' },
      {title: 'Generative AI Chatbots',
    desc: `Develop conversational experiences for websites and applications that answer common questions, explain services, guide users through information and help them identify the next appropriate step.`,
    example:'A government service portal could help citizens understand eligibility information, identify required documents and navigate available services. Official rules and critical decisions should remain governed by verified information and established processes.' },
      {title: 'Document Intelligence & Summarization',
    desc: `Help users work with lengthy or complex documents by generating summaries, extracting key points, comparing information and organizing content into structured outputs.`,
    example:'A project management platform could summarize progress reports and highlight reported delays, outstanding actions and important updates for review by project managers.' },
      {title: 'AI-Powered Customer Support',
    desc: `Integrate assistants with approved support content, product documentation and relevant customer-service systems. Depending on the integration, they can answer routine questions, suggest troubleshooting steps and help prepare or route support requests.`,
    example:'A software company could offer an in-product assistant that explains features, finds relevant help articles and prepares a support ticket when an issue requires human intervention.' },
      {title: 'Content & Knowledge Generation',
    desc: `Build features that help authorized users draft, rewrite, classify or summarize content based on supplied context and approved templates.`,
    example:'A sales platform could help teams prepare initial proposal drafts from approved service descriptions and project information, leaving staff to verify the details and finalize the document.' },
      {title: 'AI Assistants Embedded in Business Applications',
    desc: `Bring conversational AI directly into an existing workflow instead of making users switch to a separate AI tool. Assistants can be designed around the information, permissions and actions relevant to a specific application.`,
    example:'' },
  
]

const AI_CREATE_VALUES = [
  { title: 'Government & eGovernance',desc: 'Citizen information assistants, scheme-related FAQs, document guidance and internal knowledge retrieval.' },
  { title: 'Healthcare Administration',desc: 'Assistance with non-clinical information, administrative documentation and internal knowledge resources, subject to privacy requirements.' },
  { title: 'Education',desc: 'Learning-resource assistants, course information, administrative support and question-answering over approved study material.' },
  { title: 'Financial Services',desc: 'Internal policy search, document summaries and customer information assistance with appropriate access controls and review.' },
  { title: 'Manufacturing & Engineering',desc: 'Technical manual search, product documentation assistance and maintenance knowledge retrieval.' },
  { title: 'Corporate & Enterprise',desc: 'HR policy assistants, IT helpdesk support, onboarding information and knowledge discovery across departments.' }, 
]



const INTEGRATING_AI = [
  { title: `Relevant Knowledge Sources`, desc: 'Ground responses in approved information where appropriate.', },
  { title: 'Access & Data Protection', desc: 'Respect user permissions and protect sensitive information.', },
  { title: 'Response Validation', desc: 'Test factual accuracy, relevance, consistency and handling of unsupported questions.', },
  { title: 'Human Oversight', desc: 'Route sensitive, ambiguous or high-impact requests for appropriate review.', },
  { title: 'Integration & Monitoring', desc: 'Connect with existing applications and monitor response quality, usage and operating costs.', },
  { title: 'Continuous Improvement', desc: 'Refine prompts, knowledge sources and workflows as requirements change.', },
 
]
export default function GenAIIntelligentAssistants() {
  

  return (
    <>
     <MetaInfo
      title={`${label} ${SITE.metaTagPostText}`} 
      description={metaDesc}
      keywords=""
      />
      <main id="main-content" className="page-wrapper">
         <div className="page-hero">
           <div className="bg-grid bg-grid--fill" aria-hidden="true" />
           <div className="container">
             {/* <div className="section-label">- AI/ML Solutions -</div> */}
             <Breadcrumb />
             <h1 data-aos="fade-up" data-aos-delay={100}>
              {/* GenAI & LLM Solutions */}
              {label}
              </h1>
             <p className="page-subtitle" data-aos="fade-up" data-aos-delay={200}>
             {/* Build LLM-powered applications that automate and enhance business workflows. */}
             {pageDesc}
             </p>
             
             <div className="inner-page-actions">
               <Button  href={ROUTES.SALES_ENQUIRY}  variant="primary" icon="fa-arrow-right" iconPos="right"  data-aos="fade-up" data-aos-delay={200}>
                 Get a Free Quote
               </Button>
              
             </div>
           </div>
         </div>
                {/* section 1 */}
                 <section className="bg-linear-gradient-light section-py " >
               <div className="container">
                    
         
                 {/* Row 2 — */}
                  <p className='text-center' data-aos="fade-down">
                      Businesses hold valuable information across documents, websites, databases, knowledge bases and enterprise applications. Finding the right information quickly—and turning it into something useful—can be difficult when people must search through multiple systems or rely on manual support. Generative AI makes it possible to build applications that understand natural-language questions and generate relevant responses, summaries, explanations and other content.
                  </p>
               
                     <p className='text-center' data-aos="fade-down">
                      CruxBytes team can develop generative AI-powered features and intelligent assistants that help people interact with information more naturally. These capabilities can be incorporated into websites, customer portals, internal applications, SaaS platforms and other digital products.
                  </p>
                  <p className='text-center' data-aos="fade-down">
                     The objective is not simply to add a chatbot. It is to make information more accessible and help users complete meaningful tasks.
                  </p>
                  <h6 className='pt-4 text-center'>What We Can Build</h6>
                 <div className="wcs-grid wcs-grid--3 pt-4">
                   {WE_CAN_BUILD.map((card, i) => (
                     <div
                       key={card.title}
                       className="wcs-card-offer"
                       data-aos="fade-left"
                       data-aos-delay={(i % 3) * 80}
                     >
                       {/* <i className={`${card.icon} wcs-icon`} aria-hidden="true" /> */}
                       <h3 className="wcs-offer-title">{card.title}</h3>
                       <p className="wcs-offer-desc" style={{ whiteSpace: 'pre-line' }}>{card.desc}</p>
                      
                      {card.example !== "" && <><h6 className='pt-4'>Use Case: </h6> 
                      <p className="wcs-offer-desc">{card.example}</p></>}
                     </div>
                   ))}
                 </div>
               </div>
             </section>
             {/* section 2 */}
             <section className="section-py " aria-labelledby="pux-outcomes-heading">
           <div className="container">
             <div className="sc-ai-row sc-tm-row--sticky-heading">
               <div className="sc-tm-content" data-aos="fade-left">        
              <h2 id="impact-heading" >
                     <span className="impact-heading-dark">Applications Across</span>
                     <span className="impact-heading-light">Industries</span>
                   </h2>
                   
               </div>
               <div  data-aos="fade-right">
                 <div className="wcs-grid wcs-grid--3">
                   {AI_CREATE_VALUES.map((card, i) => (
                     <div
                       key={card.title}
                       className="wcs-card wcs-card--static wcs-card--start  bg-peach"
                       data-aos="fade-up"
                       data-aos-delay={(i % 3) * 80}
                     >             
                       <h3 className="wcs-title"  >{card.title}</h3>
                       <p className="wcs-desc">{card.desc}</p>
                     </div>
                   ))}
                 </div>
               </div>
         
             </div>
            
           <div className="comparison-intro mb-0" data-aos="fade-left">
           <div className='pt-4 d-flex align-items-center'>
             <h5>Turn Business Information into Useful Conversations</h5>
         </div>
         
           <div className="wcs-actions comparison-intro-cta"  data-aos="fade-right">
             <Button href={ROUTES.SALES_ENQUIRY} variant="primary" icon="fa-arrow-right" iconPos="right">
                           Get Started
               </Button>
           </div>
         </div>
           </div>
         </section>
         
           {/* ── Section 3 */}
                 <section className="section-py  bgs-section--tint" aria-labelledby="egovernance-partner-heading" style={{ borderRadius:"0" }}>
                   
         
                   <div className="container">
                    <div className="" data-aos="fade-up">
                       <div className="section-card__content ">
                         <h2 className='text-center' id="egovernance-partner-heading">
                           Designed for Useful, Responsible AI
                         </h2>
                        
                       </div>
                   <p data-aos="fade-up" className='section-px2'>Generative AI systems can produce inaccurate or incomplete responses. A reliable solution therefore requires more than connecting an application to a language model. Depending on the use case, our development considerations include:</p>
                     <div className="wcs-grid">
                       {INTEGRATING_AI.map((item, i) => (
                         <div
                           key={item.title}
                           className="wcs-card   bg-white"
                           data-aos="fade-up"
                           data-aos-delay={i * 80}
                         >
                           <h3 className="text-secondary wcs-title" >0{i+1}</h3>
                           {i > 0 && <div className="sc-code-divider" aria-hidden="true" />}
                           {/* <i className={`fa-solid ${item.icon} wcs-icon`} aria-hidden="true" /> */}
                           <h3 className="text-secondary wcs-title">{item.title}</h3>
                           <p className="text-secondary wcs-desc">{item.desc}</p>
                         </div>
                       ))}
                     </div>
                     
                     
                     </div>
                   </div>
                 </section>
                  {/* Section4 */}
               <section className="section-py ">
                         <div className="container ">
                 <div className="on-demand-split">
                           {/* ── LEFT ── */}
                  <div className="cp-timeline" data-aos="fade-right" aria-label="Our hiring process">
                 
                   <div className="cp-timeline-header">
                     <h2 >From a Question to a Working AI Experience</h2>
                     <p >
                     We begin by understanding what users need to find, understand or accomplish. From there, we define the assistant's scope, identify suitable information sources, design the interaction, integrate the required technology and test realistic scenarios before deployment.
                     </p>
                     <p>The result is an AI-enabled experience built around a specific purpose—not just a conversational interface added for appearance.</p>
                   </div>     
                 </div>
                                   {/* ── RIGHT:  ── */}
                   <div   data-aos="fade-left">  
                     <div className="contact-form-wrap" style={{backgroundColor:'var(--brand-100)'}}>
                       <h6>Make Your Applications Easier to Understand and Use</h6>
                       <p style={{ paddingBottom: '1.2rem' }}>
                         Explore how generative AI and intelligent assistants can help your customers, employees and stakeholders find information and complete everyday tasks more effectively.
                       </p>
                       
                     </div>
                   </div>
         
                           </div>
                  
                         </div>
                  </section>
         <TransformBanner />
         </main></>
  )
}